<section class="content-header">
    <h1>
        {{ titulo }}<br/>
        <small>{{ subtitulo }}</small>
    </h1>

    <ol class="breadcrumb">
        
        <ng-container *ngFor='let p of conteudoCaminho; first as isFirst'>
            
            <li class="active">
                <a [routerLink]='p.caminho'>
                    <i class="fas fa-angle-right" *ngIf='isFirst'></i>
                    {{ p.nome | replaceParams: conteudoId }}
                </a>
            </li>
        </ng-container>
    </ol>
</section>